/**
 * Possible subscription states.
 * @name SUBSCRIPTION_STATE
 * @type {Object}
 */
export const SUBSCRIPTION_STATE = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
  NONE: 'NONE'
}

/**
 * Possible disconnect reasons.
 * @name DISCONNECT_REASONS
 * @type {Object}
 */
export const DISCONNECT_REASONS = {
  GONE: 'GONE',
  LOST_CONNECTION: 'LOST_CONNECTION'
}
